import { render, staticRenderFns } from "./WizardSetup.vue?vue&type=template&id=3786b09e&"
import script from "./WizardSetup.vue?vue&type=script&lang=js&"
export * from "./WizardSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports